import React, { useEffect } from 'react';
import {
  Box,
  Center,
  FormControl,
  FormLabel,
  GridItem,
  Input,
  SimpleGrid,
  useBreakpointValue,
} from '@chakra-ui/react';
import Spinner from '../../../components/Spinner';
import { documentTypeToString } from '../../../domain/documentType';
import { legalTypeToString } from '../../../domain/legalType';
import { useFetch } from '../../../hooks/useFetch';
import { useDataForm } from '../hooks/useDataForm';
import { SectionHeading } from '../../../components/SectionHeading';

export const MerchantsDataTab = () => {
  const { controls, reset } = useDataForm();
  const { data, error, loading } = useFetch<any>('/merchants-view');
  const columns = useBreakpointValue({ 'md': 1, 'lg': 2 });

  useEffect(() => {
    if (data) {
      reset({
        ...data,
        legal_type: legalTypeToString(data.legal_type),
        representative_type: documentTypeToString(data.representative_type),
      });
    }
  }, [data]);

  if (loading) {
    return <Spinner />;
  }

  return <Center>
    <Box maxWidth="50em" >
      <form>
        <SectionHeading label="Datos Generales" />

        <SimpleGrid columns={columns} spacing="xl" paddingBottom="xl" marginBottom="xl" >
          <FormControl>
            <FormLabel>ID Comercio</FormLabel>
            <Input type="text" {...controls.identifier} disabled />
          </FormControl>
          <FormControl>
            <FormLabel>Entidad</FormLabel>
            <Input type="text" {...controls.legal_type} disabled />
          </FormControl>

          <FormControl>
            <FormLabel>Razón social</FormLabel>
            <Input type="text" {...controls.business_name} disabled />
          </FormControl>
          <FormControl>
            <FormLabel>RFC</FormLabel>
            <Input type="text" {...controls.RFC} disabled />
          </FormControl>
          <FormControl>
            <FormLabel>Actividad económica</FormLabel>
            <Input type="text" {...controls.activity} disabled />
          </FormControl>
        </SimpleGrid>

        <SectionHeading label="Información representante legal"></SectionHeading>
        <SimpleGrid columns={columns} spacing="xl" paddingBottom="xl" marginBottom="xl">
          <GridItem colSpan={2}>
            <FormControl>
              <FormLabel>Caracter</FormLabel>
              <Input type="text" {...controls.character} disabled />
            </FormControl>
          </GridItem>
          <FormControl>
            <FormLabel>Nombre del representante</FormLabel>
            <Input type="text" {...controls.representative_firstname} disabled />
          </FormControl>
          <FormControl>
            <FormLabel>Apellido del representante</FormLabel>
            <Input type="text" {...controls.representative_lastname} disabled />
          </FormControl>
          <FormControl marginRight="xl">
            <FormLabel>Tipo de documento</FormLabel>
            <Input type="text" {...controls.document_type} disabled />
          </FormControl>
          <FormControl>
            <FormLabel>Número de documento</FormLabel>
            <Input type="text" {...controls.document_number} disabled />
          </FormControl>
        </SimpleGrid>
      </form>
    </Box>
  </Center>;
};
